module.exports = MaterialUI.DialogContent;